var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    id: "_Ebene_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5776367,12.869873C14.4631348,11.8240967,15,10.4742432,15,8.9997559c0-3.3085938-2.6914062-6-6-6s-6,2.6914062-6,6           s2.6914062,6,6,6c1.4746094,0,2.824585-0.5369873,3.8703613-1.4226074l6.776123,6.776123l0.7070312-0.7070312L13.5776367,12.869873z           M9,13.9997559c-2.7568359,0-5-2.2431641-5-5s2.2431641-5,5-5s5,2.2431641,5,5S11.7568359,13.9997559,9,13.9997559z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default "data:image/svg+xml,%3csvg focusable='false' version='1.1' id='_Ebene_' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' enable-background='new 0 0 24 24' xml:space='preserve'%3e %3cpath d='M13.5776367,12.869873C14.4631348,11.8240967,15,10.4742432,15,8.9997559c0-3.3085938-2.6914062-6-6-6s-6,2.6914062-6,6 s2.6914062,6,6,6c1.4746094,0,2.824585-0.5369873,3.8703613-1.4226074l6.776123,6.776123l0.7070312-0.7070312L13.5776367,12.869873z M9,13.9997559c-2.7568359,0-5-2.2431641-5-5s2.2431641-5,5-5s5,2.2431641,5,5S11.7568359,13.9997559,9,13.9997559z'%3e%3c/path%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };